import "element-ui/lib/theme-chalk/index.css";
import Vue from 'vue'
import App from './App.vue'


import router from "./router";
import store from './store/store';
import ElementUI from "element-ui";

// 引入jquery
import $ from './utils/jquery.js';
import global_ from './utils/Global.js'//引用文件，设置全局变量

// console.log('jquery移入测试');
// console.log($(window).height())
// 安装
// npm install v-viewer --save
// 预览组件
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

// 视频组件
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// 配置axios
// import Axios from 'axios'
import myhttp from "@/utils/http.js";
Vue.prototype.$post = myhttp.post;
Vue.prototype.$get = myhttp.get;

Vue.prototype.$postfile = myhttp.postfile;

Vue.prototype.GLOBAL = global_//把全局变量挂载到Vue实例上面

// 註冊 饿了么 UI
Vue.use(ElementUI);

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        "inline": false,  //启用 inline 模式 默认false
        "button": true,　　//显示右上角关闭按钮 默认true
        "navbar": false,　　//显示缩略图导航 默认true
        "title": false,　　//显示当前图片的标题 默认true
        "toolbar": false,　　// 显示工具栏 默认true
        "tooltip": true,　　// 显示缩放百分比 默认true
        "movable": true,　　//图片是否可移动 默认true
        "zoomable": true,　　//图片是否可缩放 默认true
        "rotatable": true,　　//图片是否可旋转 默认true
        "scalable": true,　　//图片是否可翻转 默认true
        "transition": true,　　//使用css3过度 默认true
        "fullscreen": true,　　//是否全屏 默认true
        "keyboard": false,　　//是否支持键盘 默认true
        "url": "data-source" //设置大图片的URL
    }
});

// 注册自定义组件
import PerViews from './components/per_mode/index.js'
Vue.use(PerViews);


Vue.config.productionTip = false

new Vue({
	router,
	store:store,
  render: h => h(App),
}).$mount('#app')
